import { useData } from "@hooks/useData";
import http from "@core/fetch";
import apiConfig from "@apiConfig";
import { components } from "@apiSchema";
import { ID } from "@models";

export interface TopPerformingChain {
    id: ID | null;
    rank: number;
    name: string;
    logoUrl: string;
    score: number;
}

export interface CategoryProfileBrandPerformanceData {
    categories: string[];
    chains: TopPerformingChain[];
}

export const EMPTY_CATEGORY_PROFILE_BRAND_PERFORMANCE: CategoryProfileBrandPerformanceData = {
    categories: [],
    chains: [],
};

const REQUEST_TYPE: keyof typeof apiConfig = "get category profile top performing chains";

type CategoryProfileBrandPerformanceResponse = components["schemas"]["SnapCategoryProfileTopPerformingModel"];

function mapBrandPerformance(response: CategoryProfileBrandPerformanceResponse): CategoryProfileBrandPerformanceData {
    const chains = (response.chains ?? [])
        .map(({ id, rank, name, logoUrl, percentageScore }) => ({
            id: response.hasAccess ? id ?? null : null,
            rank: rank ?? 0,
            name: name ?? "",
            logoUrl: logoUrl ?? "",
            score: percentageScore ?? 0,
        }));

    return {
        categories: (response.menuRatingCategories ?? []).filter((name) => !!name),
        chains,
    };
}

async function getCategoryProfileBrandPerformance(id: ID): Promise<CategoryProfileBrandPerformanceData> {
    try {
        const response: CategoryProfileBrandPerformanceResponse = await http.get(REQUEST_TYPE, { id });
        return mapBrandPerformance(response);
    } catch (error) {
        console.error("Fetch error:", REQUEST_TYPE, error);
        return EMPTY_CATEGORY_PROFILE_BRAND_PERFORMANCE;
    }
}

export default function useCategoryProfileBrandPerformance(id: ID) {
    return useData<CategoryProfileBrandPerformanceData>(
        EMPTY_CATEGORY_PROFILE_BRAND_PERFORMANCE,
        getCategoryProfileBrandPerformance,
        id,
    );
}
